/**
 * Route for `igaming-responsible-gambling-filters-self-excluded`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingResponsibleGamblingFiltersSelfExcludedPage } from "../features/igaming-responsible-gambling-filters-self-excluded/IgamingResponsibleGamblingFiltersSelfExcludedPage";

export const igamingResponsibleGamblingFiltersSelfExcludedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-responsible-gambling-filters-self-excluded",
	component: IgamingResponsibleGamblingFiltersSelfExcludedPage,
});

export default igamingResponsibleGamblingFiltersSelfExcludedRoute;
